import { reinitializeAllSwipers } from './swiper.js';
document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    document.addEventListener('change', function (event) {
		if (event.target.matches('.front-sort-by-select')) {

			document.querySelectorAll('.zwssgr-main-wrapper').forEach(function (element) {
				element.setAttribute('data-onload-first', 'false');
			});

			const mainWrapper = event.target.closest('.zwssgr-main-wrapper');
	
			if (!mainWrapper) return;
	
			const postId = mainWrapper.getAttribute('data-widget-id');
	
			if (!postId) {
				console.error('Post ID not found');
				return;
			}
	
			const selectedValue = event.target.value;
			const selectedKeywordElement = mainWrapper.querySelector('.zwssgr-front-keywords-list li.selected');
			const keyword = selectedKeywordElement ? selectedKeywordElement.getAttribute('data-zwssgr-keyword') : '';
	
			const mainDivWrapper = mainWrapper.querySelector('.zwssgr-front-review-filter-wrap')?.nextElementSibling;
			if (!mainDivWrapper) return;
	
			const listToApnd = mainDivWrapper.querySelector('.zwssgr-slider.zwssgr-list');
			const gridToApnd = mainDivWrapper.querySelector('.zwssgr-slider.zwssgr-grid-item');
	
			const ratingFilter = mainDivWrapper.getAttribute('data-rating-filter');
			const layoutType = mainDivWrapper.getAttribute('data-layout-type');
			const bgColorLoad = mainDivWrapper.getAttribute('data-bg-color');
			const textColorLoad = mainDivWrapper.getAttribute('data-text-color');
			const enableLoadMore = mainDivWrapper.getAttribute('data-enable-load-more');
			let isFirstLoad = mainWrapper.getAttribute('data-onload-first')

			// Set `data-onload-first` to false after first interaction
			mainWrapper.setAttribute('data-onload-first', 'false');
	
			if (enableLoadMore === "1") {
				window.zwssgrLoadMoreButton = `<button class="load-more-meta zwssgr-load-more-btn" data-page="2" data-post-id="${postId}" data-rating-filter="${ratingFilter}" style="background-color: ${bgColorLoad}; color: ${textColorLoad};">Load More</button>`;
			}
			else{
				window.zwssgrLoadMoreButton = `<button class="load-more-meta zwssgr-load-more-btn" data-page="2" data-post-id="${postId}" data-rating-filter="${ratingFilter}" style="background-color: ${bgColorLoad}; color: ${textColorLoad}; display:none;">Load More</button>`;
			}
	
			mainDivWrapper.querySelectorAll('.load-more-meta').forEach(button => button.remove());
	
			const xhr = new XMLHttpRequest();
			xhr.open('POST', load_more.ajax_url, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					const response = JSON.parse(xhr.responseText);
	
					if (!response.data.content || response.data.content.trim() === '') {
						const errMsg = `<p class="zwssgr-no-found-message">${response.data.err_msg}</p>`;
	
						if (listToApnd) listToApnd.innerHTML = errMsg;
						if (gridToApnd) gridToApnd.innerHTML = errMsg;
	
						['#zwssgr-slider1', '#zwssgr-slider2', '#zwssgr-slider3', '#zwssgr-slider4', '#zwssgr-slider5', '#zwssgr-slider6', '#zwssgr-slider7', '#zwssgr-slider8'].forEach(selector => {
							const element = mainDivWrapper.querySelector(selector);
							if (element) element.innerHTML = errMsg;
						});
	
						return;
					}
	
					if (listToApnd) {
						listToApnd.innerHTML = '';
						listToApnd.insertAdjacentHTML('beforeend', response.data.content);
					}
	
					if (gridToApnd) {
						gridToApnd.innerHTML = '';
						gridToApnd.insertAdjacentHTML('beforeend', response.data.content);
					}
	
					['#zwssgr-slider1', '#zwssgr-slider2', '#zwssgr-slider3', '#zwssgr-slider4', '#zwssgr-slider5', '#zwssgr-slider6', '#zwssgr-slider7', '#zwssgr-slider8'].forEach(selector => {
						const element = mainDivWrapper.querySelector(selector);
						if (element) {
							setTimeout(() => reinitializeAllSwipers(element), 100);
							element.innerHTML = '';
							element.insertAdjacentHTML('beforeend', response.data.content);
						}
					});
	
					if (['list-1', 'list-2', 'list-3', 'list-4', 'list-5', 'list-6', 'list-7',
						 'grid-1', 'grid-2', 'grid-3', 'grid-4', 'grid-5', 'grid-6', 'grid-7'].includes(layoutType)) {
						if (response.data.disable_button !== true) {
							mainDivWrapper.insertAdjacentHTML('beforeend', window.zwssgrLoadMoreButton);
						}
					}
	
					if (['popup-1', 'popup-2', 'popup-3', 'popup-4'].includes(layoutType)) {
						if (response.data.disable_button !== true) {
							document.querySelector('.scrollable-content')?.insertAdjacentHTML('beforeend', window.zwssgrLoadMoreButton);
						}
					}
				}
			};
	
			const params = new URLSearchParams();
			params.append('action', 'zwssgr_load_more_meta_data');
			params.append('front_sort_by', selectedValue);
			params.append('post_id', postId);
			params.append('front_keyword', keyword);
			params.append('onload_first', isFirstLoad);
			params.append('nonce', load_more.nonce);
	
			xhr.send(params);
		}
	});

});